import {
  gql
} from "@apollo/client"

const QUERY_SITE_DATA = gql`
  query siteData {
    welcome: pageDescriptions(where: {section: "welcome"}) {
      id
      title
      body
      image {
        url
      }
      imageMobile {
        url
      }
    }
    bannerMessages(where: { enabled: true }) {
      message
      clinics
    }
    clinics {
      id
      url
      name
      street1
      street2
      city
      zip
      phone
      fax
      email
      officeHours {
        ... on Hour {
          note
          open
          day
          close
        }
      }
      image {
        url
      }
      googleMapsUrl
      appointmentUrl
      displayOnAppointmentsPage
      payUrl
      buyContactsUrl
      latitudeLongitude
      socialMedia {
        ... on SocialLink {
          id
          type
          url
        }
      }
      bulletinSmall {
        html
      }
      bulletinLarge {
        html
      }
    }
    announcements(where: {enabled: true}) {
      headline
      body
      url
      clinics
    }
    bios(first: 100, where: {enabled: true}) {
      category
      slug
    }
    services(first: 100) {
      serviceType
      slug
      clinic
      priority
    }
  }
`

const QUERY_HOME_DATA = gql`
  query homeData {
    missionStatements: pageDescriptions(where: { section: "mission-statement" }) {
      clinic
      body
    }
    splashCarousels(where: { enabled: true}) {
      headline
      body
      image {
        url
      }
      imageMobile {
        url
      }
      url
      clinic
    }
  }
`

const QUERY_SERVICES_DATA = gql`
  query servicesData {
    services(first: 100) {
      title
      clinic
      shortDescription
      serviceType
      icon
      slug
      url
      priority
    }
    pageDescriptions(where: {section: "services"}) {
      title
      body
      clinic
    }
  }
`

const QUERY_SERVICE_DATA = gql`
  query servicesData($clinic: Office, $slug: String!) {
    services(where: {clinic: $clinic, slug: $slug}) {
      title
      clinic
      fullDescription {
        raw
        html
        references {
          __typename
          ... on Asset {
            url
            handle
          }
        }
      }
      serviceType
      brands(first: 50) {
        ... on ServiceBrand {
          title
          image {
            url
          }
          url
          enabled
        }
      }
      icon
      priority
    }
  }
`

const QUERY_APPOINTMENTS_DATA = gql`
  query appointsmentData {
    pageData: pageDescriptions(where: {section: "appointments"}) {
      title
      body
      image {
        url
      }
      imageMobile {
        url
      }
      clinic
    }
    doctors: bios(where: {enabled: true, category: doctor}) {
      id
      name
      title
      locations
      image {
        url
      }
      priority
    }
  }  
`

const QUERY_ORDER_CONTACTS_DATA = gql`
  query orderContactsData {
    pageData: pageDescriptions(where: {section: "orderContacts"}) {
      title
      body
      image {
        url
      }
      imageMobile {
        url
      }
      clinic
    }
    clinics {
      name
      street1
      street2
      city
      zip
      buyContactsUrl
      bulletinSmall {
        html
      }
    }
  }  
`

const QUERY_PAY_BILL_DATA = gql`
  query payBillData {
    pageData: pageDescriptions(where: {section: "pay-bill"}) {
      title
      body
      image {
        url
      }
      imageMobile {
        url
      }
      clinic
    }
  }  
`

const QUERY_CONTACT_DATA = gql`
query contactData {
  clinics {
    id
    url
    name
    bulletinSmall {
      html
    }
  }
  genericDescription: pageDescriptions(where: {section: "contact"}) {
    title
    body
  }
}
`

const QUERY_ABOUT_DATA = gql`
  query aboutData {
    pageDescriptions(where: {section: "about"}) {
      title
      body
      image {
        url
      }
      imageMobile {
        url
      }
      clinic
    }
    bios(first: 100, where: {enabled: true}) {
      id
      name
      title
      body
      category
      locations
      image {
        url
      }
      priority
      slug
    }
  }
`

const QUERY_BIO_DATA = gql`
  query bioData($slug:String!, $category:BioCategory!) {
    bios(where: {enabled: true, category: $category, slug: $slug}) {
      id
      name
      title
      body
      category
      locations
      image {
        url
      }
      priority
      slug
    }
  }
`

const QUERY_PATIENTS_DATA = gql`
  query servicesData {
    services(first: 100, where: { serviceType: patients }) {
      id
      clinic
      title
      shortDescription
      serviceType
      icon
      slug
      url
      priority
    }
    pageDescriptions(where: {section: "patients"}) {
      title
      body
      clinic
    }
  }
`

export {
  QUERY_SITE_DATA,
  QUERY_BIO_DATA,
  QUERY_HOME_DATA,
  QUERY_CONTACT_DATA,
  QUERY_ABOUT_DATA,
  QUERY_SERVICES_DATA,
  QUERY_SERVICE_DATA,
  QUERY_APPOINTMENTS_DATA,
  QUERY_ORDER_CONTACTS_DATA,
  QUERY_PAY_BILL_DATA,
  QUERY_PATIENTS_DATA,
}